// TEMPORARY pilot full resync: remove with the admin full-resync endpoint.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmModal } from '../../components/ConfirmModal/ConfirmModal';
import { TranslationKey } from '../../i18n/translationKeys';
import type { FullResyncPromptProps } from './types';

export const FullResyncPrompt: React.FC<FullResyncPromptProps> = ({ onConfirm, onCancel }) => {
    const { t } = useTranslation();

    return (
        <ConfirmModal
            heading={t(TranslationKey.Home.LastSync.FullResync.Title)}
            body={t(TranslationKey.Home.LastSync.FullResync.Body)}
            confirmLabel={t(TranslationKey.Home.LastSync.FullResync.Confirm)}
            cancelLabel={t(TranslationKey.Home.LastSync.FullResync.Cancel)}
            onConfirm={onConfirm}
            onCancel={onCancel}
            modalTestId="home-full-resync-modal"
            confirmBtnTestId="home-full-resync-confirm-btn"
            cancelBtnTestId="home-full-resync-cancel-btn"
        />
    );
};
